import { render, staticRenderFns } from "./PredictionDetails.vue?vue&type=template&id=387f5a1f&scoped=true&"
import script from "./PredictionDetails.vue?vue&type=script&lang=js&"
export * from "./PredictionDetails.vue?vue&type=script&lang=js&"
import style0 from "./PredictionDetails.vue?vue&type=style&index=0&id=387f5a1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387f5a1f",
  null
  
)

export default component.exports